// extracted by mini-css-extract-plugin
export default {"block":"ol","error":"pl","required":"ql"};